export const styleIcone = {
    fontSize:"1.3em",
    margin:"0 .5em"
  };